import { render, staticRenderFns } from "./WebhookConfig.vue?vue&type=template&id=7055df8a"
import script from "./WebhookConfig.vue?vue&type=script&lang=js"
export * from "./WebhookConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports